import UserIcon from "../icons-svg/UserIcon";
import UserSearchIcon from "../icons-svg/UserSearchIcon";
import ConnectionSearchIcon from "../icons-svg/ConnectionSearchIcon";
import ConnectionIcon from "../icons-svg/ConnectionIcon";
import dashboardIcon from "../icons-svg/dashboard.svg";
import ModelIcon from "../icons-svg/ModelIcon";
import DeviceIcon from "../icons-svg/DeviceIcon";
import IconSearchLicence from "../../src/icons-svg/icon_search-licence.svg";
import iconTabBuyApprove from "../../src/icons-svg/icon_tab_buy-approve.svg";
import iconBuyApprove from "../../src/icons-svg/icon_buy-approve.svg";
import SearchLicenceIcon from "../../src/icons-svg/SearchLicenceIcon";
import SearchLicenceTabIcon from "../../src/icons-svg/SearchLicenceTabIcon";
import LicenceIcon from "../../src/icons-svg/LicenceIcon";
import LicenceTabIcon from "../../src/icons-svg/LicenceTabIcon";

const navData = [
  {
    id: 1,
    title: "Users",
    icon: (
      <UserIcon className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline text-[#069AFF]" />
    ),
    tabIcon: (
      <UserIcon className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline" />
    ),
    childs: [
      {
        id: 11,
        title: "Users Search",
        component: "admin/user/User",
        componentProps: {},
        icon: (
          <UserSearchIcon className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline text-[#6F3EFF]" />
        ),
        tabIcon: (
          <UserIcon className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline" />
        ),
      },
      {
        id: 12,
        title: "Connection Search",
        component: "admin/connection/ConnectionSearch",
        componentProps: {},
        icon: (
          <ConnectionSearchIcon className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline text-[#FFBA0D]" />
        ),
        tabIcon: (
          <ConnectionSearchIcon className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline" />
        ),
      },
    ]
  },
  // {
  //   id: 2,
  //   title: "Dashboard",
  //   icon: (
  //     <img
  //       src={dashboardIcon}
  //       className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline "
  //       alt="dashboard"
  //     />
  //   ),
  //   tabIcon: (
  //     <img
  //       src={dashboardIcon}
  //       className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline "
  //       alt="dashboard"
  //     />
  //   ),
  //   childs: [
  //     {
  //       id: 21,
  //       title: "Model Search",
  //       componentProps: {},
  //       icon: (
  //         <ModelIcon className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline text-[#EF8506]" />
  //       ),
  //       tabIcon: (
  //         <ModelIcon className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline !text-white" />
  //       ),
  //       component: "admin/tvDashboard/TvDashboard",
  //     },
  //     {
  //       id: 22,
  //       title: "Device Search",
  //       componentProps: {},
  //       icon: (
  //         <DeviceIcon className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline text-[#069AFF]" />
  //       ),
  //       tabIcon: (
  //         <DeviceIcon className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline !text-white" />
  //       ),
  //       component: "admin/device/DeviceSearch",
  //     },
  //   ],
  // },
  // {
  //   id: 3,
  //   title: "Licence",
  //   icon: (
  //     <LicenceIcon
  //       className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline
  //                 fill-current"
  //     />
  //   ),
  //   tabIcon: (
  //     <LicenceTabIcon
  //       className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline
  //                !text-white fill-current"
  //     />
  //   ),
  //   childs: [
  //     {
  //       id: 31,
  //       title: "Licence Search",
  //       component: "admin/licence/Licences",
  //       componentProps: {},
  //       icon: (
  //         <SearchLicenceIcon className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline" />
  //       ),
  //       tabIcon: (
  //         <SearchLicenceTabIcon className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline" />
  //       ),
  //     },
  //   ],
  // },
  // {
  //   id: 32,
  //   title: "Payment List",
  //   componentProps: {},
  //   icon: (
  //     <ModelIcon className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline text-[#EF8506]" />
  //   ),
  //   tabIcon: (
  //     <ModelIcon className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline !text-white" />
  //   ),
  //   component: "admin/licence/PaymentList",
  // },
  // {
  //   id: 33,
  //   title: "Sales List",
  //   componentProps: {},
  //   icon: (
  //     <ModelIcon className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline text-[#069AFF]" />
  //   ),
  //   tabIcon: (
  //     <ModelIcon className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline !text-white" />
  //   ),
  //   component: "admin/licence/SalesList",
  // },
  // {
  //   id: 34,
  //   title: "New Licence",
  //   icon: (
  //     <ModelIcon className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline text-[#069AFF]" />
  //   ),
  //   tabIcon: (
  //     <ModelIcon className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline !text-white" />
  //   ),
  //   component: "admin/newLicence/NewLicence",
  // },
  // {
  //   id: 35,
  //   title: "Customer Offer",
  //   componentProps: {},
  //   icon: (
  //     <ModelIcon className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline text-[#069AFF]" />
  //   ),
  //   tabIcon: (
  //     <ModelIcon className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline !text-white" />
  //   ),
  //   component: "admin/licence/CustomerOffer",
  // },
  // {
  //   id: 36,
  //   title: "Buy Approve",
  //   componentProps: {},
  //   icon: (
  //     <img
  //       src={iconBuyApprove}
  //       className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline"
  //       alt="buyApprove"
  //     />
  //   ),
  //   tabIcon: (
  //     <img
  //       src={iconTabBuyApprove}
  //       className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline"
  //       alt="buyApprove"
  //     />
  //   ),
  //   component: "admin/buyApprove/BuyApproves",
  // }
]

export const additionalTabs = [
  {
    title: "Connection",
    tabIcon: (
      <ConnectionIcon className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline" />
    ),
  },
  {
    title: "User",
    tabIcon: (
      <UserIcon className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline" />
    ),
  },
  {
    title: "Edit",
    tabIcon: (
      <UserIcon className="inline-block h-4 w-4 ltr:mr-2 rtl:ml-2 align-baseline" />
    ),
  },
];

export default navData;
